<div class="container-fluid">
  <div class="row">
    <h3
      id="alertsHeading"
      class="text-primary mb-0 h5"
    >
      Alerts
    </h3>
    <div class="col-md-8">
      <div *ngFor="let category of alerts; let catIdx = index">
        <h2
          id="alertCategoryLabel"
          aria-level="4"
          class="h4 fw-bold fs-6 text-dark mb-0 mt-3"
        >
          {{ category?.alertCategory }}
        </h2>

        <form [formGroup]="$any(alertsFormGroup.at(catIdx))">
          <ul class="list-group list-group-flush">
            <li
              *ngFor="let preference of category.preferences; let prefIdx = index"
              class="list-group-item ps-0 pe-0 d-flex justify-content-between align-items-center"
            >
              <span
                [id]="'alertLabel-' + catIdx + '-' + prefIdx"
                tabindex="0"
              >
                {{ preference?.alertDescription }}
              </span>

              <nr-toggle-switch
                [label]="preference?.alertDescription"
                [formControl]="getIsActiveControl(catIdx, prefIdx)"
                (toggleChange)="onAlertSubscriptionChange()"
              ></nr-toggle-switch>
            </li>
          </ul>
        </form>
      </div>
    </div>
  </div>
</div>
